if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

$(function(){
  // If the device is iOS add a class to the body so we can do specific CSS for it
  if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
    var body = document.body || document.documentElement
    body.classList.add('is-iOS')
  }

  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($(this).closest('#CartContainer') && $('body').hasClass('drawer-right-open')) {
      if ($('#ajaxcart-agree').is(':checked')) {
        $(this).submit();
      } else {
        if ($('.cart-agree-error').length > 0) return false

        var errorText = $('<span class="cart-agree-error">Bitte stellen Sie sicher, dass dieses Kästchen markiert ist, bevor Sie zur Kasse gehen.</span>')
        var $label = $('.cart-agree-label')
        var $products = $('.ajaxcart-products')
        $label.append(errorText)
        $products.css({
          top: parseInt($products.css('top'), 10) + errorText.height() + 'px'
        })

        return false;
      }
    }

    if ($(this).closest('form.cart')) {
      if ($('#cart-agree').is(':checked')) {
        $(this).submit();
      } else {
        if ($('.cart-agree-error').length > 0) return false

        var errorText = $('<span class="cart-agree-error">Bitte stellen Sie sicher, dass dieses Kästchen markiert ist, bevor Sie zur Kasse gehen.</span>')
        var $label = $('.cart-agree-label')
        var $products = $('.ajaxcart-products')
        $label.append(errorText)
        $products.css({
          top: parseInt($products.css('top'), 10) + errorText.height() + 'px'
        })

        return false;
      }
    }
  });

    $('.accordion__toggle').click(function(e){
            e.preventDefault();
            $(this).parent().toggleClass('open');
        });

        /* Cookie Policy */

        $('.cookie-policy .close').click(function(e){
            e.preventDefault();
            $('.cookie-policy').addClass('cookie-policy-hide');
            $('.cookie-policy').hide();
            Cookies.set('cookie-policy', 'true', { expires: 3650 });
        });

        if(Cookies !== undefined && Cookies.get('cookie-policy') === undefined  ){
            $('.cookie-policy').show();
        } else {
            $('.cookie-policy').hide();
        }

        // User wants to stay, drop a cookie so they don't see popup again
        function locationStay(){
            var store_country = getThisCountry();
            Cookies.set('stay-'+store_country, 'true', {expires: 3650 });
            $('.store-switcher').fadeOut();
            $('body').removeClass('modal-open');
        }

        /* Forgot Password */
        function showRecoverPasswordForm() {
            $('#RecoverPasswordForm').show();
            $('#CustomerLoginForm').hide();
        }

        function hideRecoverPasswordForm() {
            $('#RecoverPasswordForm').hide();
            $('#CustomerLoginForm').show();
        }

        $('#RecoverPassword').on('click', function(e) {
           e.preventDefault();
           showRecoverPasswordForm();
       });

       $('#HideRecoverPasswordLink').on('click', function(e) {
           e.preventDefault();
           hideRecoverPasswordForm();
       });

       if (window.location.hash.indexOf('recover') !== -1 ){
           showRecoverPasswordForm();
       }

        /* Currenct Switcher */
        $('.currency-switcher .select').click(function(e){
            e.preventDefault();
            $(this).toggleClass('on');
            $('.currency-switcher ul').toggleClass('open');
        });

        /* Scroll Down Arrow */

        $('#scrollDown').click(function() {
            var target = $(this);
            $('html, body').animate({
              scrollTop: target.offset().top + (target.height() + 30)
            }, 1000);
            return false;
        });

        /* Megamenu Sub Menu Hover Open */

        $('li.submenu-toggle').on('mouseover', function(){
            $(this).parents('.submenus').find('.open').removeClass('open');
            $(this).addClass('open');
        });

        $('.megamenu-nav-panel').on('mouseleave', function(){
            $('li.submenu-toggle').removeClass('open');
            $('li.submenu-toggle').first().addClass('open');
        });

        /* Product Variants */
        /*
            When a choice is clicked we want to stop the link.
            We then want to change the id input so the add to cart button will add the right variant.
            Then we need to update the product price, the URL.

            If you need to change the image or SKU or anything else, just add a data- attribute on
            the bao_variant_options.liquid and then add some logic below.
        */
        $('.bao-selectors .choice').click(function(e){

            // prevent the link
            e.preventDefault();

            // update the product id
            $('input[name=id]').val($(this).data('id'));

            // change the price
            $('#ProductPrice').html($(this).data('price'))

            // update the URL
            var pageUrl = window.location.origin + window.location.pathname +'?variant=' + $(this).data('id');
            window.history.pushState('', '', pageUrl);

            // update the choice select status
            $(this).siblings().removeClass('active');
            $(this).addClass('active');
        })


        /* Drawers */
        $('.close-drawers').click(function(e){
            $('body').removeClass('drawer-left-open').toggleClass('drawer-right-open');
        });

        $('.open-drawer').click(function(e){
            e.preventDefault(); // disable cart link

            // open the correct drawer, check the other one is shut
            if($(this).data('drawer') == 'left'){
                $('body').removeClass('drawer-right-open').toggleClass('drawer-left-open');
            }else{
                $('body').removeClass('drawer-left-open').toggleClass('drawer-right-open');
            }
        });

        $('body').click(function(e){

            // as long as you're not clicking on a drawer or a button to open a drawer
            if(($('body').hasClass('drawer-left-open') || $('body').hasClass('drawer-right-open')) && !$(e.target).hasClass('drawer__inner') && !$(e.target).hasClass('open-drawer') && $(e.target).closest('.drawer__inner').length == 0){

                // shut any open drawer
                $('body').removeClass('drawer-right-open').removeClass('drawer-left-open');
            }
        });

        /* Modals */

        $('.modal__close').click(function(){
            $('.modal').removeClass('open');
            $('body').removeClass('modal-open');
        });

        $('.open-modal').click(function(){
            $('.modal[data-modal='+$(this).data('modal')+']').addClass('open');
            $('body').addClass('modal-open');
        });


        /* FAQ */

        $('.faq__category').click(function(){
            $('.faq__category').removeClass('active');
            $(this).addClass('active');
            $('.faq__questions').removeClass('active');
            $('.faq__questions[data-category='+$(this).data('category')+']').addClass('active');
        });


        $('.faq__question').click(function(){
            $(this).parent().toggleClass('open')
        });

        /* Tabs */

        $('#tabs .titles ul li').click(function(e){
            e.preventDefault();
            var targetTab = $(this).find('a').attr('href');
            $(this).parents('.tabs').find('.fade').removeClass('fade');
            $(this).parents('.tabs').find('.active').removeClass('active');
            $(this).addClass('active');
            $(this).siblings().addClass('fade');
            $(targetTab).addClass('active');
        });

        $('#tabs--collapsible .titles ul li').click(function(e){
            e.preventDefault();
            var targetTab = $(this).find('a').attr('href');
            if ($(this).hasClass('active')) {
                $(this).parents('.tabs').find('.fade').removeClass('fade');
                $(this).parents('.tabs').find('.active').removeClass('active');
            } else {
                $(this).parents('.tabs').find('.fade').removeClass('fade');
                $(this).parents('.tabs').find('.active').removeClass('active');
                $(this).addClass('active');
                $(this).siblings().addClass('fade');
                $(targetTab).addClass('active');
            }
        });

        /* Product Gallery */

        var $imageContainer = $('.js-ProductChooser_ImageContainer')
        $('.prd-Product_ThumbnailLink').on('click', function(e){
            e.preventDefault();
            var newImg = $(this).attr('href');
            $('#featured-image').attr('src', newImg);
        });
        $('.prd-Product_ThumbnailLink').hover(function () {
          if ($imageContainer.hasClass('js-ProductChooser_ImageContainer-active') === false) return

          var newImg = $(this).attr('href');
          $('#featured-image').attr('src', newImg);
          $imageContainer.addClass('js-ProductChooser_ImageContainer-hover')
        }, function () {
          $imageContainer.removeClass('js-ProductChooser_ImageContainer-hover')
        })

        /* Search Box */
        var $searchBtn = $('a.search');
        var $searchBox = $('.search-box');
        $searchBtn.on('click', function(){
            $searchBox.toggleClass('search-box--show');
            if ($searchBox.hasClass('search-box--show')) {
                $searchBox.focus();
            }
        });

      /* Load More */
      var isPaginationLoading = false;
      var LoadMore = function(container, e) {
          var button = e.target;

          var itemsPerPage = $(container + ' .item').length;

          if(isPaginationLoading){
              return;
          }

          isPaginationLoading = true;

          var currentPage = $(button).data('page');
          var nextUrl = $(button).data('url')+'?page='+(currentPage+1);

          $(button).addClass('btn--loading');

          $.ajax({
              url: nextUrl,
              dataType: 'html',
              success: function(html) {
                  var newItems = $(html).find(container + ' .item').length;
                  $(container + ' .grid').append($(html).find(container + ' .item'));
                  isPaginationLoading = false;
                  $('#LoadMore').data('page', currentPage+1);
                  $('#LoadMore').removeClass('btn--loading');
                  if(newItems !== itemsPerPage){
                      $('#LoadMore').hide();
                  }
              }
          });
      }

      var $body = $('body');
      if ($body.is('.template-collection, .template-search')) {
          $('#LoadMore').click(LoadMore.bind(this, '.listing-container'));
      } else if ($body.hasClass('template-blog')) {
          $('#LoadMore').click(LoadMore.bind(this, '.blog__articles'));
      }

      $('#close-mobile-drawer').click(function(){
          $('body').removeClass('drawer-left-open');
      });

      /* Sliders */

      $('.collection-carousel').flickity({
          // options
          cellAlign: 'center',
          contain: true,
          wrapAround: true,
          pageDots: false
      });

      $('.product-carousel').flickity({
          // options
          cellAlign: 'center',
          contain: true,
          wrapAround: true,
          pageDots: false
      });

      $('.article-carousel').flickity({
          // options
          cellAlign: 'center',
          contain: true,
          wrapAround: true,
          pageDots: false
      });

      $('.design-tips-carousel').flickity({
          // options
          cellAlign: 'center',
          contain: true,
          wrapAround: true
      });

      // Scroll effect for header
      $( window ).scroll(function() {
      	if ($(window).scrollTop() > 50){
          $('body').addClass('scrolling');
        } else {
          $('body').removeClass('scrolling');
        }
      });

      if ($("#instafeed").length){
      // Instafeed
      var feed = new Instafeed({
        get: 'user',
        userId: '7580708204',
        clientId: 'f24160e6af1b49cfb669dfb999a71dce',
        accessToken: '7580708204.1677ed0.1b0329fadb6a49069578c894a1bc92fa',
        limit: 5,
        resolution: 'standard_resolution',
      });
      feed.run();
      }

      // register of fundraising
      // Scroll to
      $('.scrollto').click(function() {
        var elementClicked = $(this).attr("href");
        var destination = $(elementClicked).offset().top;
        $("html:not(:animated),body:not(:animated)").animate({ scrollTop: destination - 80}, 800 );
        return false;
      });

      // Accordion on collection pages
      var acc = document.getElementsByClassName("col-Accordion_Trigger");
      var i;

      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
          this.classList.toggle("col-Accordion_Trigger-active");
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight){
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }

})

// Tabs on About page
if ($(".template-page-about").length){

  function openCity(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
  }

  // Get the element with id="defaultOpen" and click on it
  document.getElementById("defaultOpen").click();

}

$(window).load(function(){
    var $blogPostCarousel = $('.blog-post-carousel');
    var sliderHeight = $blogPostCarousel.height();
    $blogPostCarousel.find('.carousel-cell > .grid').css('height', sliderHeight);
});

function range(start, count, reverse) {
  if (typeof(reverse) === 'undefined') reverse = false

  return Array.apply(0, Array(count))
    .map(function (element, index) {
      return reverse === false
        ? start + index
        : start - index
    })
}

function getKeyByValue (object, value) {
  return Object.keys(object).filter(function (key) {
    return object[key] === value
  })[0]
}

function shopifyAssetUrl (key) {
  return '//cdn.shopify.com/s/files/1/2570/9456/files/' + key + '_100x100.png'
}

function getOffsetTop (el, parent) {
  parent = parent || document.body || document.documentElement

  var offsetTop = 0

  do {
    if (!isNaN(el.offsetTop)) {
      offsetTop += el.offsetTop
    }

    el = el.offsetParent
  } while (el !== parent || el !== document.body)

  return offsetTop
}

function scrollToY (scrollTargetY, speed, easing) {
  scrollTargetY = scrollTargetY || 0
  speed = speed || 300
  easing = easing || 'easeInOutQuint'
  var scrollY = window.scrollY
  var currentTime = 0
  var time = Math.max(
    0.1,
    Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8)
  )

  var easingEquations = {
    easeOutSine: function easeOutSine (pos) {
      return Math.sin(pos * (Math.PI / 2))
    },
    easeInOutSine: function easeInOutSine (pos) {
      return -0.5 * (Math.cos(Math.PI * pos) - 1)
    },
    easeInOutQuint: function easeInOutQuint (pos) {
      if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 5)
      }
      return 0.5 * (Math.pow(pos - 2, 5) + 2)
    }
  }

  function tick () {
    currentTime += 1 / 60

    var position = currentTime / time
    var t = easingEquations[easing](position)

    if (position < 1) {
      window.requestAnimationFrame(tick)

      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t)
    } else {
      window.scrollTo(0, scrollTargetY)
    }
  }

  tick()
}
